import Portal from "@Portals/components/Portal";
import Countries from "@Pages/homepage/features/countries/components/Countries";
import {useTranslation} from "@Translation/hooks/useTranslation";

function PopularLocations() {
    const popularDestinationsLabel = useTranslation("bus_rental.popular_destinations")

    return (
        <Portal id="bus-rent-popular-locations-portal">
            <h1>{popularDestinationsLabel}</h1>
            <Countries/>
        </Portal>
    )
}

export default PopularLocations